import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@/../environments/environment';
import { TipoCondicaoEspecial, TipoCondicaoEspecialRequest } from '@/models';
import { PageResponse, StatusCount } from './pagination.types';

@Injectable({
  providedIn: 'root',
})
export class TipoCondicaoEspecialService {
  private baseUrl = `${environment.apiUrl}/admin/tipos-condicoes-especiais`;

  constructor(private http: HttpClient) {}

  getTiposCondicoesEspeciais(): Observable<TipoCondicaoEspecial[]> {
    return this.http.get<TipoCondicaoEspecial[]>(this.baseUrl);
  }

  getTipoCondicaoEspecial(id: number): Observable<TipoCondicaoEspecial> {
    return this.http.get<TipoCondicaoEspecial>(`${this.baseUrl}/${id}`);
  }

  createTipoCondicaoEspecial(data: TipoCondicaoEspecialRequest): Observable<TipoCondicaoEspecial> {
    return this.http.post<TipoCondicaoEspecial>(this.baseUrl, data);
  }

  updateTipoCondicaoEspecial(id: number, data: TipoCondicaoEspecialRequest): Observable<TipoCondicaoEspecial> {
    return this.http.put<TipoCondicaoEspecial>(`${this.baseUrl}/${id}`, data);
  }

  deleteTipoCondicaoEspecial(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }

  toggleStatus(id: number, active: boolean): Observable<TipoCondicaoEspecial> {
    return this.http.patch<TipoCondicaoEspecial>(`${this.baseUrl}/${id}/toggle-status`, { active });
  }

  /**
   * Lista tipos de condições especiais paginados
   * GET /api/admin/tipos-condicoes-especiais/paginado
   */
  listarPaginado(
    page: number = 0,
    size: number = 10,
    sortBy: string = 'nome',
    sortDirection: 'ASC' | 'DESC' = 'ASC',
    apenasAtivos?: boolean
  ): Observable<PageResponse<TipoCondicaoEspecial>> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString())
      .set('sortBy', sortBy)
      .set('sortDirection', sortDirection);
    
    if (apenasAtivos !== undefined) {
      params = params.set('apenasAtivos', apenasAtivos.toString());
    }
    
    return this.http.get<PageResponse<TipoCondicaoEspecial>>(`${this.baseUrl}/paginado`, { params });
  }

  /**
   * Obtém contagem de status dos tipos de condições especiais
   * GET /api/admin/tipos-condicoes-especiais/status
   */
  getStatus(): Observable<StatusCount> {
    return this.http.get<StatusCount>(`${this.baseUrl}/status`);
  }
}
